import styled from 'styled-components';

export const SpinnerStyled = styled.div`
  position: fixed;
  width: 100%;
  z-index: ${(p) => p.theme.zIndexes.absoluteUp};
  height: 100%;
  background: ${(p) => p.background ?? 'rgba(255, 255, 255, 0.7)'};
  top: 0;
  bottom: 0;
  transition: all 0.5s ease;

  .loader {
    margin: 45vh auto;
    width: 125px;
    height: 70px;
    position: relative;
  }

  .loader svg path {
    fill: none;
    stroke-linecap: butt;
    stroke-width: 56;
    stroke-miterlimit: 100;
    stroke-dasharray: 1800;
    stroke-dashoffset: 0;
    animation: loader_path 2s linear infinite;
  }

  @keyframes loader_path {
    0% {
      stroke-dashoffset: 5400;
    }
    100% {
      stroke-dashoffset: 1800;
    }
  }
`;
